import React from 'react';
import { connect } from 'react-redux';
import { chatOn, chatOff, popupBot, listObjetives } from '../../actions';
import unsplash from '../../apis/unsplash';
import perfil from '../../Media/perfil.png';
import { Image, Card, Row, Col, Container, Button, Modal, Form, Tooltip, OverlayTrigger, ProgressBar } from 'react-bootstrap';
import { dataBaseManager, progressOKR } from '../hupUtils/utils';
import ImportObjective from './importObjective';



const timeoutLength2 = 1000;
const styleButton = { borderRadius: '15em', color: '#070b41' }

const styleWidthCard = { background: 'linear-gradient(to bottom, #f8edd200, #f8edd2)' };

class listImportante extends React.Component {

    state = {
        images: [], buscar: ['company', 'business', 'worker', 'HR', 'team', 'city'],
        detailObjective: null,
        WorkFlow: null, endKey: null,
        prioridadx: [{ prio: 'inmediato', color: 'red' }, { prio: 'urgente', color: 'yellow' }, { prio: 'normal', color: 'olive' }],
        factors: null,
        utilsFactor: null,
        objetiveStart: null,
        modalOpen: false,
        resultRoot: null,
        resultCurrent: null,
        objSelResul: null,
        impactoUtils: null,
        messageCommemt: null,
        messageFile: 'Consulta tus archivos',
    };

    componentDatabase(tipo, path, objectIn, mensaje, mensajeError) {
        let men = dataBaseManager(tipo, path, objectIn, mensaje, mensajeError);
        if (men && men.mensaje)
            this.props.popupBot({ mensaje: men.mensaje });
        return men;
    }
    //vairble x aumento n cantidad terminada n*x
    //fotos de la tarjetas
    onSearchSubmit = async () => {

        const response = await unsplash.get('/search/photos', {
            params: { query: this.state.buscar[Math.round(Math.random() * 5)] },
        });
        this.setState({ images: response.data.results })
    }

    async startObject() {
        this.introObject = true;
        this.onSearchSubmit()
        let variable = {};
        let impactoFlujo = this.componentDatabase('get', `Utils/Impacto-Objetivo`);
        impactoFlujo.on('value', (snapshot) => {
            this.setState({ impactoUtils: snapshot.val() })
        });
        const starCountRef = this.componentDatabase('get', `Usuario-OKR/${this.props.userId}`);
        starCountRef.on('value', (snapshot) => {

            const ObjTrabajo = snapshot.val();
            let objetives = [];
            if (!snapshot.val()) return;
            Object.keys(ObjTrabajo).map((key2, index) => {
                /*  if (ObjTrabajo[key2].tipologia === '3') {
                      const starCountRef = this.componentDatabase('get',`Usuario-OKR/${ObjTrabajo[key2].idUsuarioGestor}/${ObjTrabajo[key2].objetivoPadre}` );
                      starCountRef.on('value', (snapshot) => {
                          if (snapshot.val()) {
                              const resultado2 = { ...ObjTrabajo[key2], avancePadre: snapshot.val().avance }
                              objetives[key2] = { ...resultado2 };
                          }
                      });
                  }
                  else {
                      */
                objetives[key2] = { ...ObjTrabajo[key2] };
                //       }
                return ObjTrabajo[key2];
            });
            variable = { ...variable, objetives }
            this.props.listObjetives(variable);
        });

        const starCountRef33 = this.componentDatabase('get', `Utilidades-Valoraciones`);
        starCountRef33.on('value', (snapshot) => {
            this.setState({ utilsFactor: snapshot.val() });
        });

        const starCountRef2 = this.componentDatabase('get', `Usuario-Task/${this.props.userId}`);
        starCountRef2.on('value', (snapshot) => {
            variable = { ...variable, tasks: snapshot.val() }
            this.props.listObjetives(variable);
        });

        const starCountRef3 = this.componentDatabase('get', `Usuario-Flujo-Trabajo/${this.props.userId}`);
        starCountRef3.on('value', (snapshot) => {
            this.setState({ WorkFlow: snapshot.val() });
        });

        //   this.handleActualizar();

    }

    calculoDeAvance() {
        if (this.props.listObjetive == null)
            return;
        const objs = this.props.listObjetive.objetives;
        let factorEqHup = [];
        //Encontrar factor
        this.setState({ ObjsFactors: [] });
        if (objs)
            Object.keys(objs).map((key, index) => {
                if (!objs[key] || !objs[key].concepto)
                    return null;
                let facPrioridad = 1;
                let facDificultad = 1;
                let facRepeticiones = 1;
                let facTipo = 1;
                let facCompartido = objs[key].tipologia === '3' ? objs[key].porcentajeResp ? objs[key].porcentajeResp * 0.01 : 1 : 1;
                let facCalidad = 1;
                let facValidacion = 1;
                let facProductividad = 1;
                //Object.keys(this.state.utilsFactor.Calidad).map((key2, index) =>{});
                Object.keys(this.state.utilsFactor.Dificultad).map((key2, index) => {
                    if (objs[key].dificultad === this.state.utilsFactor.Dificultad[key2].concepto)
                        facDificultad = this.state.utilsFactor.Dificultad[key2].valor;
                    return this.state.utilsFactor.Dificultad[key2];
                });
                Object.keys(this.state.utilsFactor.Prioridad).map((key2, index) => {
                    if (objs[key].prioridad === key2)
                        facPrioridad = this.state.utilsFactor.Prioridad[key2];
                    return this.state.utilsFactor.Prioridad[key2];
                });
                Object.keys(this.state.utilsFactor.Tipo).map((key2, index) => {
                    if (objs[key].tipo === this.state.utilsFactor.Tipo[key2].concepto)
                        facTipo = this.state.utilsFactor.Tipo[key2].valor;
                    return this.state.utilsFactor.Tipo[key2];
                });
                Object.keys(this.state.utilsFactor.ValidacionGestor).map((key2, index) => {
                    if (objs[key].estado === this.state.utilsFactor.ValidacionGestor[key2].concepto)
                        facValidacion = this.state.utilsFactor.ValidacionGestor[key2].valor;
                    return this.state.utilsFactor.ValidacionGestor[key2];
                });
                //algoritmo de medicion del trabajo
                const puntos = ((1 + facPrioridad + facTipo) * facRepeticiones * facDificultad) * facCompartido * facCalidad * facValidacion * facProductividad;
                factorEqHup.push({ key, puntos, usuario: objs[key].idUsuario })
                return null;
            });
        this.setState({ factors: factorEqHup })
    }

    guardarDetalle() {

        if (this.state.messageCommemt) {
            const newPostKey2 = this.componentDatabase('key', `Usuario-OKR/${this.props.userId}/${this.state.endKey}`);
            if (this.state.endKey != null)
                this.componentDatabase('update', `Usuario-OKR/${this.props.userId}/${this.state.endKey}/comentarios/${newPostKey2}`, {
                    usuario: this.props.userDetail.usuario.usuario,
                    tipo: 'responder',
                    concepto: this.state.messageCommemt,
                    imagen: this.props.userDetail.usuario.imagenPerfil ? this.props.userDetail.usuario.imagenPerfil : ''
                });

            this.setState({ messageCommemt: null });
            return;
        }

        let objAux = this.state.resultRoot ? this.state.resultRoot : this.state.objetives;
        alert(this.props.prioridadObj);
        const tarea = { ...objAux, detalle: this.state.detailObjective ? this.state.detailObjective : null, prioridad: this.state.prioridadx[0].prio };
        if (this.state.endKey != null)
            this.componentDatabase('insert', `Usuario-OKR/${this.props.userId}/${this.state.endKey}`, {
                ...tarea
            });
        this.setState({ detailObjective: '' });  // this.setState({ prioridadO: true });
    }

    handleActualizar = () => {
        this.timeout = setTimeout(() => {
            this.calculoDeAvance();
        }, timeoutLength2)
    }

    introObjectMain = () => {
        this.timeout = setTimeout(() => {
            this.startObject();
        }, 3000)
    }

    //Consultar espacio de trabajo
    renderConsultarEW(carpeta) {

        if (carpeta) {
            this.setState({ messageFile: 'Consulta tus archivos' })
            window.open(`https://drive.google.com/drive/folders/${carpeta}`);
        }
        else
            this.setState({ messageFile: 'no tienes ningun archivo' });

    }

    handleOpen = () => {
        this.setState({ modalOpen: true });
    }

    rendertasks(okr) {

        if (!okr || !okr.tasks)
            return;

        const tasks = Object.keys(okr.tasks).map((key, index) => {
            let classNameState = 'taskInprogress';
            let iconState = 'watch_later';
            if (okr.tasks[key].estado === 'finalizado' || okr.tasks[key].estado === 'activo') {
                if (okr.tasks[key].estado === 'finalizado') {
                    classNameState = 'taskEnd';
                    iconState = 'done';
                }
                return (

                    <Row key={key}>
                        <Col>
                            <h6 className={classNameState}>   <i className="material-icons md-12">{iconState}</i>  {okr.tasks[key].concepto}</h6>
                        </Col>
                    </Row>

                );
            }
            return null;
        });
        return <>  <h6>Tus tasks:</h6> {tasks} </>;

    }


    renderComentarios() {

        if (this.state.objetives && this.state.objetives.comentarios) {
            const opciones = Object.keys(this.state.objetives.comentarios).map((key3, index) => {
                let comentarioT = this.props.userDetail.usuario.usuario;
                if (this.state.objetives.comentarios[key3].tipo === 'feedback')
                    comentarioT = 'Gestor';
                let imagenComen = this.state.objetives.comentarios[key3].imagen ? this.state.objetives.comentarios[key3].imagen : perfil;

                const styleHedader = { background: 'rgb(238, 252, 204)', borderRadius: '2em' };
                const styleComment = { borderRadius: '2em' };

                return (
                    <Card border="light" className='message_Comment' style={styleComment} >
                        <Card.Header style={styleHedader} >
                            <Row>
                                <Col xs={2} >
                                    <Image src={imagenComen} roundedCircle className='image_icon_Comement centerTitleTask' alt='Task Hupper'></Image>
                                </Col>
                                <Col xs={10}>
                                    <h3>{this.state.objetives.comentarios[key3].usuario}</h3>
                                </Col>
                            </Row>
                        </Card.Header>
                        <Card.Body >

                            <Row>
                                <Col xs={{ span: 11, offset: 1 }} className='centerTitleTaskOn'>
                                    <Card.Text >
                                        {this.state.objetives.comentarios[key3].concepto}
                                    </Card.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 4, offset: 8 }} className='userComment'>
                                    <Card.Text >
                                        {comentarioT}
                                    </Card.Text>
                                </Col>
                            </Row>

                        </Card.Body>
                    </Card>
                );
            });
            return opciones;
        }
    }

    changeObj(objetivo) {
        if (!this.state.resultRoot && objetivo.objetives) {
            this.setState({ resultRoot: objetivo });
            Object.keys(objetivo.objetives).map((key, index) => {
                if (Object.keys(objetivo.objetives).length - 1 === index) {
                    this.setState({ objetiveStart: objetivo.objetives[key] });
                }
                return objetivo.objetives[key];
            });
        }
        this.setState({ resultCurrent: objetivo });
    }

    renderConstruirObj() {
        if (this.props.listObjetive && this.props.listObjetive.objetives) {
            let flagobjetivesTerminados = null;
            const cconsulta = this.props.listObjetive.objetives;
            let y = 0;
            const opciones = Object.keys(cconsulta).map((key2, index) => {
                y++;
                if (y > this.state.images.length)
                    y = 1;
                let resultado = 0;
                if (cconsulta[key2].estado === 'activo' || cconsulta[key2].estado === 'validar') {

                    //factor de progreso por horas 
                    let factorSemana = 0;
                    if (this.state.factors !== null) {
                        Object.keys(this.state.factors).map((endKeyac, index) => {
                            if (cconsulta[key2].idUsuario === this.state.factors[endKeyac].usuario)
                                factorSemana = factorSemana + this.state.factors[endKeyac].puntos;
                            return this.state.factors[endKeyac];
                        });

                    }
                    if (this.props.listObjetive.tasks) {

                        resultado = progressOKR(cconsulta[key2], key2, this.props.listObjetive.tasks);

                        if (resultado < 100)
                            flagobjetivesTerminados = false;
                        else if (resultado >= 100) {
                            flagobjetivesTerminados = true;

                        }
                    }


                    //Impacto de las activiadades
                    let iconoImpacto;
                    let colorImpacto;


                    if (cconsulta[key2].impacto === "1") { iconoImpacto = "monetization_on"; colorImpacto = "green"; }
                    else if (cconsulta[key2].impacto === "2") { iconoImpacto = "miscellaneous_services"; colorImpacto = "blue"; }
                    else if (cconsulta[key2].impacto === "4") { iconoImpacto = "business_center"; colorImpacto = "purple"; }
                    else if (cconsulta[key2].impacto === "3") { iconoImpacto = "location_city"; colorImpacto = "yellow"; }

                    //grafica el avance del objetivo compartido
                    let auxImage = null;
                    let objPrincipal = cconsulta[key2];
                    if (objPrincipal.tipologia === '3') {
                        y++;
                        auxImage = <Row className='rowAuxImage'>
                            <Col md={{ span: 9, offset: 8 }} xs={{ span: 5, offset: 3 }}>
                                <ProgressBar style={{ backgroundColor: '#e9fcfd' }} animated now={objPrincipal.advancedPattern >= 100 ? 100 : objPrincipal.advancedPattern === 0 ? 15 : objPrincipal.advancedPattern} label={`${objPrincipal.advancedPattern >= 100 ? 100 : objPrincipal.advancedPattern === 0 ? 15 : objPrincipal.advancedPattern}%`} />
                            </Col>
                            <Col md={{ span: 3, offset: 9 }} xs={{ span: 2, offset: 4 }}>
                                <Image className='imageOKRAux' src={this.state.images[y] ? this.state.images[y].urls.thumb : ''} alt='OKR aux' rounded />
                            </Col>
                        </Row>;

                    }
                    else if (objPrincipal.tipologia === '2') {
                        y++;
                        if (this.state.resultRoot && this.state.resultCurrent !== this.state.resultRoot)
                            objPrincipal = this.state.resultRoot;
                        else
                            objPrincipal = this.state.objetiveStart ? this.state.objetiveStart : objPrincipal;
                        let imgyAux = this.state.objetiveStart === objPrincipal ? y - 1 : y;

                        resultado = objPrincipal.advanced ? objPrincipal.advanced : resultado;
                        auxImage = <Row className='rowAuxImage'>
                            <Col md={{ span: 3, offset: 9 }} xs={{ span: 2, offset: 4 }} onClick={() => { this.changeObj(objPrincipal) }} >
                                <Image className='imageOKRAux2' src={this.state.images[imgyAux] ? this.state.images[imgyAux].urls.thumb : ''} alt='OKR aux' rounded />
                            </Col>
                        </Row>;

                    }

                    let imgy = this.state.objetiveStart === objPrincipal ? y : y - 1;
                    let kresultx = null;
                    if (this.state.objSelResul === key2) {
                        kresultx = <>
                            <Row>
                                <Col md={10} xs={12}>
                                    <h6> ○ {objPrincipal.keyResult1}</h6>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={10} xs={12}>
                                    <h6> ○ {objPrincipal.keyResult2}</h6>
                                </Col>
                            </Row>
                        </>
                    }
                    if (flagobjetivesTerminados === true)
                        this.props.popupBot({ mensaje: 'hemos terminado el objetivo  ' + objPrincipal.concepto, sleep: 35000 });


                    if (objPrincipal.concepto)
                        return (

                            <Card border="light" className='cardOKR' style={styleWidthCard} key={key2}>
                                <Card.Body >


                                    <Row>
                                        <Col md={1} xs={12}>
                                            <Row>
                                                <Col md={12} xs={3} >
                                                    <Button variant="light" className='okrButton' style={styleButton} onClick={(e, s) => {
                                                        this.setState({ endKey: key2 });
                                                        this.setState({ objetives: cconsulta[key2] });
                                                        this.setState({ comentario: null });
                                                        this.handleOpen();
                                                    }}>
                                                        <i className="material-icons md-18">chat_bubble_outline</i>
                                                    </Button>

                                                </Col>
                                                <Col md={12} xs={3}>
                                                    <OverlayTrigger
                                                        key='top'
                                                        placement='top'
                                                        overlay={
                                                            <Tooltip id={`tooltip-top`}>
                                                                {this.state.messageFile}
                                                            </Tooltip>
                                                        }>
                                                        <Button variant="light" className='okrButton' style={styleButton} onClick={() => this.renderConsultarEW(objPrincipal.carpeta)}>
                                                            <i className="material-icons md-18">attach_file</i>
                                                        </Button>

                                                    </OverlayTrigger>
                                                </Col>
                                                <Col md={12} xs={3}>

                                                    <OverlayTrigger
                                                        key='bottom'
                                                        placement='bottom'
                                                        overlay={
                                                            <Tooltip id={`tooltip-bottom`}>
                                                                {this.rendertasks(objPrincipal)}
                                                            </Tooltip>
                                                        }>
                                                        <Button variant="light" className='okrButton' style={styleButton}>
                                                            <i className="material-icons md-18">add_task</i>
                                                        </Button>

                                                    </OverlayTrigger>
                                                </Col>


                                            </Row>
                                        </Col>
                                        <Col md={{ span: 3, offset: 1 }} xs={{ span: 8, offset: 3 }}>
                                            {auxImage}
                                            <Row>
                                                <Col>
                                                    <Image className='imageOKR' style={{ marginLeft: '-1em' }} src={this.state.images[imgy] ? this.state.images[imgy].urls.thumb : ''} alt='OKR' rounded />
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col md={{ span: 6, offset: 1 }} xs={{ span: 10, offset: 1  }} className='okrConcepto'>
                                            <Row>
                                                <Col>
                                                    <h4 style={{ textAlign: 'center' }}>{objPrincipal.concepto}</h4>
                                                </Col>

                                            </Row>
                                            <Row>
                                                <Col md={{ span: 1, offset: 3 }} xs={{ span: 1, offset: 4 }}>
                                                    <div style={{ color: colorImpacto }}>
                                                        <i className="material-icons md-18">{iconoImpacto}</i>
                                                    </div>
                                                </Col>

                                            </Row>
                                            <Row>
                                                <Col className='col-kresult'>
                                                    <figure className="snip1361" onMouseOver={(e, s) => { this.setState({ objSelResul: key2 }); }}
                                                        onMouseLeave={() => { this.setState({ objSelResul: null }); }}>
                                                        <figcaption>
                                                            {kresultx}
                                                        </figcaption>
                                                    </figure>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={{ span: 5, offset: 3 }} xs={{ span: 8, offset: 1 }} >
                                            <ProgressBar style={{ backgroundColor: '#fde9fd' }} className='centerProgressBar' animated now={resultado >= 100 ? 100 : resultado === 0 ? 15 : resultado} label={`${resultado >= 100 ? 100 : resultado === 0 ? 15 : resultado}%`} />
                                        </Col>
                                    </Row>

                                </Card.Body>
                            </Card>
                        );
                }
                return null;
            });
            return opciones;

        }
        return (
            <Container fluid className="centerIntroOKR">
                <Row>
                    <Col md={{ span: 8, offset: 3 }} xs={{ span: 12, offset: 1 }} >
                        <div className="box" >
                            <h2>Ingresa tu objetivo de la semana...</h2>
                            <div className="loader9"></div>
                            <br></br>
                        </div >

                    </Col>
                </Row>
            </Container>
        );
    }


    render() {
        if (this.introObject === undefined)
            this.introObjectMain();

        const titulo = this.props.listObjetive && this.props.listObjetive.objetives ? `${this.props.titulo}` : '';
        return (
            <Row>
                <Col xs={12} >
                    <Row>
                        <Col md={{ span: 10, offset: 2 }} xs={12} className='okrTextCenter'>
                            <h2>{titulo}</h2>
                        </Col>
                    </Row>

                    <Row className='width_row_okr'>
                        <Col md={{ span: 11, offset: 1 }} xs={12} className='okrListCenter'>
                            {this.renderConstruirObj(this.state.images)}
                        </Col>
                    </Row>

                    <Row>
                        <Col className='import_OKR_bt' md={{ span: 3, offset: 7 }} xs={12}>
                            <ImportObjective />
                        </Col>
                    </Row>
                    <Modal show={this.state.modalOpen}  >
                        <Modal.Header >
                            <Modal.Title>Agrega un nuevo comentario a tu objetivo</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Container>
                                <Row>
                                    <Col className='box_comment'>
                                        {this.renderComentarios()}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form>

                                            <Form.Group controlId="ControlInput1">
                                                <Form.Label>Escribe tu comentario</Form.Label>
                                                <Form.Control name="comemt"
                                                    type="text" value={this.state.messageCommemt}
                                                    onChange={(e) => this.setState({ messageCommemt: e.target.value })} />
                                            </Form.Group>

                                        </Form>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <h4 style={{ 'text-align': 'center' }}>"Los hombres sabios hablan porque tienen algo que decir, los necios porque tienen que decir algo".</h4>
                                        <h6 style={{ 'text-align': 'center' }}>-Platón</h6>

                                    </Col>
                                </Row>
                            </Container>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="light" onClick={() => { this.setState({ modalOpen: false }) }} inverted>
                                Cancelar</Button>
                            <Button variant="primary" style={{ background: 'purple', borderRadius: '10px' }} onClick={() => { this.setState({ modalOpen: false }); this.guardarDetalle(this); }} inverted>
                                <i className="material-icons md-12">add_comment</i>  Agregar
                            </Button>

                        </Modal.Footer>

                    </Modal>
                </Col>
            </Row>


        )
    };
};

const mapAppStateToProps = (state) => (
    {
        listObjetive: state.mainReducer.listObjetive,
        prioridadObj: state.mainReducer.prioridadObj,
        userDetail: state.mainReducer.userDetail,
        userId: state.mainReducer.userId,
    });

export default connect(mapAppStateToProps, { popupBot, listObjetives, chatOn, chatOff })(listImportante);